import { createApi } from '@openx/utils/api/createApi';
import { createHttpClient } from '@openx/utils/api/createHttpClient';
import { getCacheKeyPrefix } from '@openx/utils/lib/getCacheKeyPrefix';
import { enqueueNotification } from '@openx/utils/state/notifications/actions';
import { configureStore } from '@reduxjs/toolkit';

// Dispatcher has no app-wide redux store (its only reducer was the now-removed session
// reducer). `createApi` still requires a `Store` to dispatch error notifications onto, so we
// hand it a standalone store that isn't wired into the React tree — matching prior behavior,
// where these dispatches already had no reducer to observe them.
const reduxStore = configureStore({ reducer: () => ({}) });

const clientHeader = 'X-OPENX-UI-CLIENT';
const clientHeaderValue = 'Dispatcher';
const pageHeader = 'X-OPENX-UI-PAGE';
const localForageName = 'dispatcher-cache-v2';
const cacheAge = 15 * 60 * 1000;

const cachePaths = [/\/session*/, /\/ready*/];

const { api } = createApi({
  cacheAge,
  cacheKeyPrefix: getCacheKeyPrefix,
  cachePaths,
  clientHeader,
  clientHeaderValue,
  enqueueNotification,
  localForageName,
  pageHeader,
  reduxStore,
});

export const http = createHttpClient({
  clientHeader,
  clientHeaderValue,
  pageHeader,
});

export { api };
